import React, { useEffect, useState } from "react";
import Header from "../../components/layout/header";
import img from "../../images/Rectangle 6.png";
import { FiMinus, FiPlus } from "react-icons/fi";
import customer from "../../images/customer.png";
import "./ProductDetails.css";
import Footer from "../../components/layout/footer";
import why_us from "../../images/whyus2.jpg";
import Product_review from "../../images/prodreview.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../constant";
import axios from "axios";
import { toast } from "react-toastify";
import { useCartContext } from "../../Context/CartContext";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
  FaStar,
  FaRegStar,
  FaSearchPlus,
  FaSearchMinus,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import deal_icon from "../../images/Lightning Deal.svg";
import DealOfTheDay from "../Home/DealOfTheDay";
import RelatedProducts from "../Home/RelatedProducts";
import FlashSale from "../Flash Sale/FlashSale";
import {
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import { message } from "antd";

const ProductDetails = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  let stars = Array.from({ length: 5 });
  const [showDescription, setShowDescription] = useState(true);
  const [productDetails, setProductDetails] = useState(null);
  const [orderQuantity, setOrderQuantity] = useState(1);
  const [cartItems, setCartItems] = useState([]);
  const { fetchCartCount } = useCartContext();
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [numberOfPack, setNumberOfPack] = useState(1);
  const [total, setTotal] = useState(0);
  const [ProductDescription, setProductDescription] = useState({});
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState({
    rating: 0,
    userName: "",
    email: "",
    message: "",
  });
  const [hover, setHover] = useState(null);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [selectedColor, setSelectedColor] = useState(colors[0] || "");
  const [selectedSize, setSelectedSize] = useState(sizes[0] || "");
  const guestId = localStorage.getItem("guestId");
  const userId = localStorage.getItem("userId");

  const handleQuantityChange = async (newQuantity) => {
    if (newQuantity >= 1) {
      setQuantity(newQuantity);

      try {
        const response = await axios.post(
          `${BASE_URL}/usercart/update-quantity?userId=${
            userId || guestId
          }&productId=${productDetails.productId}&orderQuantity=${newQuantity}`
        );
      } catch (error) {
        toast.error("Error updating quantity!", { position: "top-center" });
      }
    }
  };

  const handleIncrement = () => {
    if (quantity < productDetails.productStock) {
      handleQuantityChange(quantity + 1);
    } else {
      toast.warn("Currently, Few products are Out of Stock!", {
        position: "top-center",
      });
    }
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      handleQuantityChange(quantity - 1);
    }
  };

  useEffect(() => {
    const fetchProductDetails = async () => {
      const userId = localStorage.getItem("userId");
      try {
        const response = await axios.get(
          `${BASE_URL}/api/customProducts/${productId}`
        );
        setProductDetails(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };
    const fetchReviews = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/product-ratings/product/${productId}`
        );
        setReviews(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };
    fetchProductDetails();
    fetchReviews();
  }, [productId]);

  useEffect(() => {
    if (productDetails) {
      setSelectedPhoto(productDetails.prodImg1);
    }
  }, [productDetails]);

  // Function to fetch cart items
  const fetchCartItems = async () => {
    const userId = localStorage.getItem("userId");
    // console.log("userId:", userId);
    if (userId) {
      try {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId}&pageSize=10000`
        );
        setCartItems(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  const handleDescriptionClick = () => {
    setShowDescription(true);
  };

  const handleReviewsClick = () => {
    setShowDescription(false);
  };

  const decreaseQuantity = () => {
    if (orderQuantity > 1) {
      setOrderQuantity(orderQuantity - 1);
    }
  };

  const increaseQuantity = () => {
    setOrderQuantity(orderQuantity + 1);
  };

  const handleAddToCart = async (productId, productName) => {
    // console.log("productName", productName);
    let userId = localStorage.getItem("userId");

    console.log(userId);
    if (userId) {
      try {
        const existingCartItemResponse = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId}`
        );

        const existingCartItem = existingCartItemResponse.data.find(
          (item) => item.productId === productId
        );

        if (existingCartItem) {
          // If the product is already in the cart, navigate to the cart page directly
          navigate("/cart");
        } else {
          // If the product is not in the cart, add it to the cart
          await axios.post(
            `${BASE_URL}/usercart/add-product?userId=${userId}&productId=${productId}`,
            {
              productName: productName,
              productColor: selectedColor,
              productSize: selectedSize,
              totalQuantity: quantity,
            }
          );
          // Navigate to the cart page after adding to the cart
          navigate("/cart");
        }
        await fetchCartCount();
      } catch (error) {
        console.error("Error adding product to cart:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const handleGuestAddToCart = async (productId, productName) => {
    try {
      console.log("guest function clicked");
      let guestId = localStorage.getItem("guestId");

      if (!guestId) {
        console.log("No guestId found in localStorage. Creating a new one...");
        // Create guestId if not present
        const response = await axios.post(`${BASE_URL}/api/guest/create`);
        console.log("Response from guest creation API:", response);

        // Check if the response contains guestId
        if (response.data && response.data) {
          guestId = response.data;
          localStorage.setItem("guestId", guestId);
          console.log("guestId created and stored:", guestId);
        } else {
          throw new Error("guestId not returned from API");
        }
      }

      const existingCartItemResponse = await axios.post(
        `${BASE_URL}/usercart/in-cart?userId=${guestId}`
      );
      console.log("Existing cart items response:", existingCartItemResponse);

      const existingCartItem = existingCartItemResponse.data.find(
        (item) => item.productId === productId
      );

      if (existingCartItem) {
        // If the product is already in the cart, navigate to the cart page directly
        console.log("Product already in cart. Navigating to cart...");
        navigate("/cart");
      } else {
        console.log("Product not in cart. Adding to cart...");
        // If the product is not in the cart, add it to the cart
        await axios.post(
          `${BASE_URL}/api/guest-cart/add?guestId=${guestId}&productId=${productId}`,
          {
            productName: productName,
            productColor: selectedColor,
            productSize: selectedSize,
            totalQuantity: quantity,
          }
        );
        console.log("Product added to cart. Navigating to cart...");
        navigate("/cart");
      }
      await fetchCartCount();
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.error("Something went wrong! Try again later");
    }
  };

  const handleShare = (productId) => {
    if (navigator.clipboard) {
      const productDetailsUrl = `${window.location.origin}/productdetails/${productId}`;
      navigator.clipboard.writeText(productDetailsUrl);
      toast.success("Product link copied");
    }
  };

  const handleSubmitReview = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${BASE_URL}/product-ratings`, {
        productId: productId,
        userName: rating.userName,
        email: rating.email,
        message: rating.message,
        ratings: rating.rating,
      });
      // console.log(response.data);
      toast.success("Thank you for your rating! We appreciate your feedback.");
      event.target.reset();
      setRating({
        rating: 0,
        userName: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting review:", error);
      toast.error("Error submitting review. Please try again later.");
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRating((prevRating) => ({
      ...prevRating,
      [name]: value,
    }));
  };

  const getGalleryPhotos = (productDetails) => {
    if (!productDetails) return [];

    const galleryPhotos = Object.keys(productDetails)
      .filter((key) => key.startsWith("prodImg") && productDetails[key])
      .map((key) => productDetails[key]);

    return galleryPhotos;
  };
  const galleryPhotos = getGalleryPhotos(productDetails);

  // Fetch colors from the new API
  useEffect(() => {
    const fetchColorsAndSizes = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/customProducts/get-all-colors?name=${productDetails?.productName}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch colors");
        }
        const product = await response.json();

        console.log("Fetched product:", product);

        // Update the colors
        const allColors =
          product?.productColor && product.productColor !== "-"
            ? product.productColor
                .split(",")
                .map((color) => color.trim())
                .filter((color) => color !== "-")
            : [];
        setColors(allColors || []);

        // Update the sizes
        const allSizes =
          product?.productSize && product.productSize !== "-"
            ? product.productSize
                .split(",")
                .map((size) => size.trim())
                .filter((size) => size !== "-")
            : [];
        setSizes(allSizes || []);

        // Set default selected color and size after data is fetched
        if (allColors.length > 0) {
          setSelectedColor(allColors[0]);
        } else {
          setSelectedColor(""); // Set a default empty value if no colors are found
        }

        if (allSizes.length > 0) {
          setSelectedSize(allSizes[0]);
        } else {
          setSelectedSize(""); // Set a default empty value if no sizes are found
        }
      } catch (error) {
        console.error("Error fetching colors:", error);
      }
    };

    fetchColorsAndSizes();
  }, [productDetails]);

  // console.log("selectedColor", selectedColor);
  // console.log("selectedSize", selectedSize);
  return (
    <div>
      <Header />
      {productDetails && (
        <div className="product-detail-container shadow-sm">
          <div className="product-image-container">
            <div className="product-image-gallery">
              {galleryPhotos.map((photo, index) => (
                <img
                  key={index}
                  src={photo}
                  alt={`Product Image ${index + 1}`}
                  onClick={() => setSelectedPhoto(photo)}
                />
              ))}
            </div>
            {/* Image with zoom effect */}
            <div>
              <div
                className="product-single-image"
                style={{
                  width: "450px",
                  height: "450px",
                  overflow: "hidden",
                  position: "relative",
                  borderRadius: "10px", // Optional for a rounded container
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // Add a slight shadow for depth
                }}
              >
                {/* Left Arrow */}
                <button
                  onClick={() =>
                    setSelectedPhoto(
                      galleryPhotos[
                        (galleryPhotos.indexOf(selectedPhoto) -
                          1 +
                          galleryPhotos.length) %
                          galleryPhotos.length
                      ]
                    )
                  }
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    borderRadius: "50%",
                    padding: "10px",
                    cursor: "pointer",
                    zIndex: 10,
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <FaChevronLeft size={24} />
                </button>

                <TransformWrapper
                  initialScale={1}
                  minScale={1}
                  maxScale={3}
                  wheel={{ step: 0.1 }}
                  pinch={{ step: 0.1 }}
                >
                  {({ zoomIn, zoomOut, resetTransform }) => (
                    <>
                      <TransformComponent>
                        <img
                          src={selectedPhoto}
                          style={{
                            width: "450px",
                            height: "450px",
                            objectFit: "contain",
                          }}
                          alt="Product"
                        />
                      </TransformComponent>

                      <div
                        className="tools"
                        style={{
                          position: "absolute",
                          bottom: "20px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        {/* Zoom In Button */}
                        <button
                          onClick={() => zoomIn()}
                          style={{
                            backgroundColor: "#f0f0f0",
                            border: "none",
                            borderRadius: "50%",
                            padding: "10px",
                            cursor: "pointer",
                            fontSize: "24px", // Increased icon size
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Button shadow for depth
                          }}
                        >
                          <FaSearchPlus />
                        </button>

                        {/* Zoom Out Button */}
                        <button
                          onClick={() => zoomOut()}
                          style={{
                            backgroundColor: "#f0f0f0",
                            border: "none",
                            borderRadius: "50%",
                            padding: "10px",
                            cursor: "pointer",
                            fontSize: "24px", // Increased icon size
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <FaSearchMinus />
                        </button>

                        {/* Reset Button */}
                        <button
                          onClick={() => resetTransform()}
                          style={{
                            backgroundColor: "#f0f0f0",
                            border: "none",
                            borderRadius: "50%",
                            padding: "10px",
                            cursor: "pointer",
                            fontSize: "16px", // Text size for Reset
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </>
                  )}
                </TransformWrapper>

                {/* Right Arrow */}
                <button
                  onClick={() =>
                    setSelectedPhoto(
                      galleryPhotos[
                        (galleryPhotos.indexOf(selectedPhoto) + 1) %
                          galleryPhotos.length
                      ]
                    )
                  }
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    borderRadius: "50%",
                    padding: "10px",
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <FaChevronRight size={24} />
                </button>
              </div>
            </div>
          </div>
          <div className="product-details">
            <h3>{productDetails.productName}</h3>
            <div>
              {productDetails.lightning ? (
                <div className="deal-icon-container">
                  <img alt="" src={deal_icon} />
                  <div className="text-overlay">Lighting Deal</div>
                </div>
              ) : null}
              {productDetails.offered ? (
                <div
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: 23,
                  }}
                >
                  OFFER
                </div>
              ) : null}
            </div>
            <div className="product-rating">
              {[...Array(5)].map((_, index) => (
                <FaStar
                  key={index}
                  color={
                    index < Math.round(productDetails.productRatings)
                      ? "#ffc35b"
                      : "#e4e5e9"
                  }
                />
              ))}

              {/*<span style={{ color: "black" }}>
                ({productDetails.productRatings}){" "}
              </span>*/}
            </div>
            <div className="product-price">
              <span>₹{numberOfPack * productDetails.productRate}.00</span>
              <span>₹{numberOfPack * productDetails.productMRP}.00</span>
            </div>
            <div className="cart-buttons d-flex justify-content-between">
              <div className="color d-flex">
                <p>Color: {productDetails.productColor}</p>
              </div>
              <div className="size d-flex">
                <p>Size: {productDetails.productSize}</p>
              </div>
            </div>

            <div className="cart-buttons">
              {/* Color Dropdown *\/}
              {/*<div className="dropdown-menu-box">
                {colors.length > 0 && (
                  <div className="color-dropdown">
                    <p>Color</p>
                    <select
                      className="color-select"
                      value={selectedColor}
                      onChange={(e) => setSelectedColor(e.target.value)}
                    >
                      {colors.map((color, index) => (
                        <option key={index} value={color}>
                          {color}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Size Dropdown *\/}
                {sizes.length > 0 && (
                  <div className="size-dropdown">
                    <p>Size</p>
                    <select
                      className="size-select"
                      value={selectedSize}
                      onChange={(e) => setSelectedSize(e.target.value)}
                    >
                      {sizes.map((size, index) => (
                        <option key={index} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>*/}
              {productDetails?.productStock == 0 ? (
                <p style={{ color: "red", marginTop: "10px" }}>Out of Stock</p>
              ) : (
                <div className="quantity-div">
                  <p>Quantity</p>
                  <div className="cart-quantity-btn ">
                    <button type="button" onClick={handleDecrement}>
                      <FiMinus />
                    </button>
                    {quantity}
                    <button type="button" onClick={handleIncrement}>
                      <FiPlus />
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="product-buttons">
              {productDetails.productStock > 0 ? (
                <React.Fragment>
                  <button
                    type="submit"
                    className="buy-now"
                    onClick={() => {
                      const userId = localStorage.getItem("userId");
                      if (userId) {
                        handleAddToCart(
                          productDetails.productId,
                          productDetails.productName
                        );
                      } else {
                        handleGuestAddToCart(
                          productDetails.productId,
                          productDetails.productName
                        );
                      }
                    }}
                  >
                    Buy Now
                  </button>
                  {cartItems.some(
                    (item) => item.productid === productDetails.productId
                  ) ? (
                    <button type="submit" className="prod-added-cart-btn">
                      Added to cart
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="prod-cart-btn"
                      onClick={() => {
                        const userId = localStorage.getItem("userId");
                        if (userId) {
                          handleAddToCart(
                            productDetails.productId,
                            productDetails.productName
                          );
                        } else {
                          handleGuestAddToCart(
                            productDetails.productId,
                            productDetails.productName
                          );
                        }
                      }}
                    >
                      Add to cart
                    </button>
                  )}
                </React.Fragment>
              ) : (
                <div>
                  <button type="submit" className="buy-now" disabled>
                    Buy Now
                  </button>
                  <button type="submit" className="prod-cart-btn" disabled>
                    Add to cart
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="description-reviews-container">
        <div className="buttons">
          <button
            onClick={handleDescriptionClick}
            className={`description-btn ${showDescription ? "active" : ""}`}
          >
            Description
          </button>
          <button
            onClick={handleReviewsClick}
            className={`reviews-btn ${!showDescription ? "active" : ""}`}
          >
            Reviews
          </button>
        </div>
        {showDescription ? (
          <DescriptionBox productDetails={productDetails} />
        ) : (
          <ReviewsBox reviews={reviews} />
        )}
      </div>
      <div className="slider">
        <RelatedProducts
          title={"Related Products"}
          categoryName={
            productDetails ? productDetails.productCategory : "PREEMIE SIZE"
          }
        />
      </div>
      <div className="review-form-container">
        <div className="review-form">
          <img src={Product_review} alt="Product" />
          <form onSubmit={handleSubmitReview}>
            <h1>Product Review</h1>
            <div
              style={{ color: "#ffc35b" }}
              className="d-flex gap-2 justify-content-center my-2 mt-3"
            >
              {[...Array(5)].map((_, index) => {
                const ratingValue = index + 1;
                return (
                  <label key={index}>
                    <input
                      type="radio"
                      name="rating"
                      value={ratingValue}
                      style={{ display: "none" }}
                      onClick={() =>
                        setRating((prevRating) => ({
                          ...prevRating,
                          rating: ratingValue,
                        }))
                      }
                    />
                    <FaStar
                      size={30}
                      color={
                        ratingValue <= (hover || rating.rating)
                          ? "#ffc35b"
                          : "#e4e5e9"
                      }
                      onMouseEnter={() => setHover(ratingValue)}
                      onMouseLeave={() => setHover(null)}
                      style={{ cursor: "pointer" }}
                    />
                  </label>
                );
              })}
            </div>
            <p>Your Rating: {rating.rating}</p>
            <input
              className="flex my-4"
              value={rating.userName}
              onChange={handleInputChange}
              name="userName"
              placeholder="Name"
              required
            />
            <input
              className="flex my-4"
              name="email"
              value={rating.email}
              onChange={handleInputChange}
              placeholder="Email"
              required
            />
            <textarea
              className="flex my-4"
              name="message"
              value={rating.message}
              onChange={handleInputChange}
              placeholder="Message"
              required
            />
            <input className="p-2" type="submit" value="Submit" />
          </form>
        </div>
      </div>
      <div className="why-us-container">
        <div className="why-us">
          <div className="why-us-content">
            <h1>Why Us</h1>
            <p>
              At Kharutaai (Formerly Known as 'Prathamesh Balache Kapade’) we
              are dedicated to providing the Premium Quality & Comfortable
              Clothing for your Little Ones!.
              <br />
              Our Collection is designed with Love & Care, using Soft,
              Breathable Fabrics that are gentle on delicate skin!
              <br />
              Whether it's Playtime, Naptime, or a Special Occasion, our
              Clothing ensures that your Infant feels Comfortable, Cozy & always
              Stylish!
              <br />
              Trust us to dress your little bundle of Joy with the Finest
              Fabrics & Thoughtful Designs. With our In-House Manufacturing
              'Kharutaai' we're more dedicated towards our cause!
              <br />
              With our In-House Manufacturing ('Kharutaai') we're more dedicated
              towards our cause!
              <br />
              <br />
              Happy to Serve! 😃
            </p>
          </div>
          <div className="why-us-img">
            <img src={why_us} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

function DescriptionBox({ productDetails }) {
  if (!productDetails) return null;
  const pointsArray = productDetails?.productDescription2
    ? productDetails?.productDescription2?.split("\n")
    : ["No Description"];
  return (
    <div className="description-box">
      <p className="p-2">{productDetails?.productDescription}</p>
      <div className="desc-table">
        <table>
          <tbody>
            <tr>
              <td className="bold">Brand</td>
              <td>
                {typeof productDetails.productBrand === "string"
                  ? productDetails.productBrand.toUpperCase()
                  : "NA"}
              </td>
            </tr>
            <tr>
              <td className="bold">Style</td>
              <td>
                {typeof productDetails.productStyle === "string"
                  ? productDetails.productStyle.toUpperCase()
                  : "NA"}
              </td>
            </tr>
            <tr>
              <td className="bold">Size</td>
              <td>
                {productDetails.productSize === "-"
                  ? "Freesize"
                  : productDetails.productSize}
              </td>
            </tr>
            <tr>
              <td className="bold">Color</td>
              <td>
                {typeof productDetails.productColor === "string"
                  ? productDetails.productColor.toUpperCase()
                  : "NA"}
              </td>
            </tr>
            <tr>
              <td className="bold">Texture</td>
              <td>
                {typeof productDetails.productDesignNo === "string"
                  ? productDetails.productDesignNo.toUpperCase()
                  : "NA"}
              </td>
            </tr>{" "}
            <tr>
              <td className="bold">Type</td>
              <td>
                {typeof productDetails.productType === "string"
                  ? productDetails.productType.toUpperCase()
                  : "NA"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="desc-list">
        <p>About Item</p>
        <ul>
          {pointsArray.length > 0 &&
            pointsArray.map((point, index) => {
              const trimmedPoint = point.trim().replace(/âœ…/g, "✅");
              return trimmedPoint ? <li key={index}>{trimmedPoint}</li> : null;
            })}
        </ul>
      </div>
    </div>
  );
}

function ReviewsBox({ reviews }) {
  if (!reviews || reviews.length === 0) {
    return <div className="noreviews">No Reviews Available</div>;
  }

  return (
    <Swiper
      effect={"coverflow"}
      modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
      slidesPerView={"auto"}
      loop={reviews.length > 1}
      grabCursor
      style={{
        "--swiper-navigation-color": "white",
        "--swiper-navigation-size": "40px",
        "--swiper-pagination-color": "white",
        "--swiper-pagination-bullet-size": "11px",
      }}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      initialSlide={0}
      centeredSlides={true}
      coverflowEffect={{
        rotate: 0,
        stretch: 15,
        depth: 100,
        modifier: 1.2,
        slideShadows: false,
      }}
    >
      {reviews.map((review) => (
        <SwiperSlide
          key={review.id}
          className="reviewslide product-reviewslide"
        >
          <div className="d-flex align-items-center gap-3">
            <h3 style={{ fontWeight: "bold" }}>{review.userName}</h3>
          </div>
          <p style={{ paddingTop: "20px" }}>{review.message}</p>
          <div className="d-flex gap-1">
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                color={i < review.ratings ? "#ffc35b" : "#e4e5e9"}
              />
            ))}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
export default ProductDetails;
